const schema = require('./shipping-method');
const { validateSchema } = require('../common/validate-schema');

function validateShippingMethodSchema(request) {

    validateSchema(schema, request);
}

module.exports = {
    validateShippingMethodSchema
};
